import { IncentiveOfferStatus } from 'modules/incentivesMarket/types';
import { IncentiveOfferDetailContextType } from '../types/IncentiveOfferDetailContextType';

export const incentiveOfferDetailInitValue: IncentiveOfferDetailContextType = {
  data: {
    societyId: '',
    societyName: '',
    offer: null,
    offerStatus: IncentiveOfferStatus.ACTIVE,
    offerReference: '',
    acceptanceHistory: [],
    incentiveOfferOperations: [],
    priceContext: {
      currentOfferPrice: 0,
      lastTransactionPrice: 0,
      avgSellOffersPrice: 0,
      officialValuation: 0,
      userAvgBuyPrice: 0,
    },
    timelineSteps: [],
    sellerInfo: null,
    availableShares: 0,
    offerRemainingUnits: 0,
    daysRemaining: 0,
    isAdmin: false,
    isExpired: false,
    isOwnOffer: false,
    userBeneficiaryIds: [],
    beneficiaryQueryParam: '',
    isLoading: true,
    hasPartnerBuyer: false,
    purchaseQuantity: 1,
    commissionRate: 0.015,
  },
  actions: {
    handleGoBack: () => {},
    handlePurchaseQuantityChange: () => {},
    handleBuyShares: () => {},
    handleViewOtherOffers: () => {},
    handleGoToOperation: () => {},
  },
};
